import SuperFetch from '../../../superFetch.js';

class RecommendProductApi {
  /**
   *  [추천 상품 리스트] 추천 상품 리스트 요청하기
   */
  getRecommendProductList = (data) => SuperFetch.post('/recommend/product/list', data);

  /**
   *  [추천 상품 상세] 추천 상품 상세 요청하기
   */
  getRecommendProductDetail = (data) => SuperFetch.post('/recommend/product/detail', data);

  /**
   *  추천 상품 복사하기 전 필요한 데이터 가져오기
   */
  prepareCopyRecommendProduct = (data) => SuperFetch.post('/recommend/product/insert/preparation/copy', data);

  /**
   *  추천 상품 등록하기 전 필요한 데이터 가져오기
   */
  prepareCreateRecommendProduct = (data) => SuperFetch.post('/recommend/product/insert/preparation/insert', data);

  /**
   *  추천 상품에 연결할 아이템 리스트 요청하기
   */
  getRecommendProductItemList = (data) => SuperFetch.post('/recommend/product/insert/preparation/list', data);

  /**
   *  추천 상품 복사하기
   */
  createRecommendProduct = (data) => SuperFetch.post('/recommend/product/insert', data);

  /**
   *  추천 상품 등록하기(엑셀)
   */
  createRecommendProductByExcel = (data) => SuperFetch.post('/recommend/product/insert/excel/upload', data);

  /**
   *  전체 상품 리스트 EXCEL 다운로드
   */
  getRecommendProductItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/product/insert/preparation/list/excel/download', data);

  /**
   *  선택된 상품 리스트 EXCEL 다운로드
   */
  getSelectedRecommendProductItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/product/insert/preparation/list/excel/download/selected', data);

  /**
   *  상품 리스트 EXCEL 업로드
   */
  setRecommendProductItemListExcelUpload = (data) =>
    SuperFetch.post('/recommend/product/insert/preparation/list/excel/upload', data);

  /**
   *  추천 상품 상세 아이템 리스트 EXCEL 다운로드
   */
  getRecommendProductDetailItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/product/detail/excel/download', data);
}

export default new RecommendProductApi();
